import React from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import validateForm from "./CollectionMethodValidation";
import { useWebServer } from "../../../../../providers";
import { useHistory } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import { editCollectionMethod } from "../../../../../actions";
import CollectionMethodForm from "./CollectionMethodForm"

const CollectionMethodEdit = ({ collectionMethodId, editCollectionMethod, ...otherProps }) => {
  const { sendRequest } = useWebServer();
  const history = useHistory();
  const onSave = async (collectionMethod) => {
    await editCollectionMethod(collectionMethodId, collectionMethod, sendRequest);
    history.push(ROUTES.collectionMethods);
  };

  return (
    <CollectionMethodForm
      {...otherProps}
      onSave={onSave} />
  );
};

const mapStateToProps = (state, ownProps) => {
  const collectionMethodId = ownProps.match.params.id;
  const initialValues = _.pick(
    state.collectionMethods[collectionMethodId],
    "displayName",
    "vectorType",
    "trapType",
    "attractantType",
    "description"
  );

  return {
    collectionMethodId,
    initialValues,
  };
};

const formWrapped = reduxForm({
  form: "CollectionMethodEdit",
  validate: validateForm,
})(CollectionMethodEdit);

export default connect(mapStateToProps, { editCollectionMethod })(formWrapped);
